<template>
    <div class="container">
        <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
        <div class="wrap">

            <div class="meal-list-wrap unified-meal" ref="content" :style="`animation-duration:${animationDuration}s`">
                <div class="meal-list" v-for="(itemPar, indexPar) in infos" :key="indexPar">
                    <div class="meal-date">{{ itemPar.endDate || '' }} {{ itemPar.startDate || '' }}</div>
                    <div class="meal-block">
                        <div class="meal-item" v-for="(itemSub, indexSub) in filterTJCdata" :key="indexSub">
                            <div class="meal-title">
                                <span>{{ `${itemSub.name || ''}(${itemSub.price || 0}元)` }}</span>
                                <span>价格变化 {{ renderArrow(itemSub.compareIncreaseDecrease) }}</span>
                            </div>
                            <div class="meal-content">
                                {{ renderContent(itemPar, indexSub) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { TAB_MAP_VALUE } from '@/assets/js/constants';
import schoolAndDate from "./schoolAndDate.vue";
export default {
    props: {
        deptId: {
            type: String,
            default: ''
        },
        outletsId: {
            type: String,
            default: ''
        },
        tjcData: {
            type: Array,
            default: () => [],
        },
        dateTime: {
            type: String,
            default: '',
        },
        schoolName: {
            type: String,
            default: '',
        },
    },
    components: { schoolAndDate, },
    data() {
        return {
            infos: [],
            animationDuration: 0,
        }
    },
    watch: {
        tjcData: function (newVal) {
            if (newVal && newVal.length > 0) {
                console.log(`===> (item=12) ${TAB_MAP_VALUE['12']} 早午晚数据 <===`,
                    JSON.parse(JSON.stringify(this.tjcData)))
                this.refreshPage()
            }
        }
    },
    computed: {
        filterTJCdata: function () {
            try {
                const arr = JSON.parse(JSON.stringify(this.tjcData))
                arr.pop()
                return arr
            } catch (error) {
                return []
            }
        },
    },
    mounted() {
        this.getMenuPriceAnnouncementList()
        setTimeout(() => {
            this.refreshPage()
        }, 1000)
    },
    methods: {

        // 获取餐次信息
        getMenuPriceAnnouncementList() {
            const param = {
                outletsId: this.outletsId,
                recipeType: 0
            }
            this.$get(this.$api.getMenuPriceAnnouncementList, param).then(res => {
                console.log(`===>(item=12) ${TAB_MAP_VALUE['12']} 列表数据 <===`, res)
                this.infos = res.data
                this.refreshPage()
            })
        },

        refreshPage() {
            this.$nextTick(() => {
                this.calcDocumentHeight()
            })
        },

        renderArrow(value) {
            if (value === 'gt') {
                return '↑'
            }
            if (value === 'lt') {
                return '↓'
            }
            return '–'
        },

        renderContent(itemPar, indexSub) {
            try {
                const keyName = {
                    0: 'breakfastList',
                    1: 'lunchList',
                    2: 'dinnerList',
                }
                const conArr = itemPar[keyName[indexSub]]
                const conStr = conArr.map(item => item.name).join('、')
                return conStr ? conStr : '无'
            } catch (error) {
                return '无'
            }
        },

        // 计算高度
        calcDocumentHeight() {
            if (this.$refs.content.offsetHeight > 960) {
                this.animationDuration = (this.$refs.content.offsetHeight / 200) * 5.5
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes scroll-up {
    0% {
        transform: translateY(vh(80));
        /* 文本初始位置，向上偏移 0 */
    }

    100% {
        transform: translateY(-100%);
        /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
    }
}

$fontColor: #A84E14;
$borderColor: #d5957c;

.container {
    position: relative;
}


$wrapHeight: 830;

.wrap {
    height: vh($wrapHeight);
    width: 100%;
    overflow: hidden;
    border-radius: 3px;
    font-weight: bold;
    background: #efbcaf;



    .meal-list-wrap {
        padding: vh(12) vh(18);
    }

    .meal-list {
        margin-bottom: vh(20);

        .meal-date {
            color: #000;
            text-align: left;
            font-size: vh(22);
            margin-bottom: vh(10);
        }

        .meal-block {
            overflow: hidden;
            display: flex;
            border: 1px solid $borderColor;
            color: $fontColor;
            border-radius: vh(10);

            .meal-item {
                flex: 1;
                font-size: vh(16);
                white-space: normal;
                text-align: left;

                &:nth-of-type(2) {
                    border-left: 1px solid $borderColor;
                    border-right: 1px solid $borderColor;
                }

                .meal-title {
                    font-size: vh(14);
                    padding: vh(6) 0;
                    text-align: center;
                    background: #e59c88;

                    >span:nth-of-type(1) {
                        margin-right: vh(20);
                    }
                }

                .meal-content {
                    word-wrap: break-word;
                    padding: vh(10) vh(12);
                }
            }
        }
    }
}

.overhide {
    overflow: hidden;
    height: vh($wrapHeight - 50);
}

.unified-meal {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    animation-name: scroll-up;
    animation-duration: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>